function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, Children, cloneElement } from "react";
import { cva } from "class-variance-authority";
import { Icon } from "../Icon/index.js";
import { cn } from "../../common/helpers.js";
const classes = cva([
    'flex',
    'flex-row',
    'flex-nowrap',
    'gap-x-2',
    'items-center',
    'text-sm',
    'fill-primary'
]);
const modifyChild = (child)=>/*#__PURE__*/ cloneElement(child, {
        noUnderline: true,
        color: 'primary'
    });
/**
 * Breadcrumbs - [API](https://scl.sharp.com/?path=/docs/components-breadcrumbs) | [DSM](https://sharphealthcare.notion.site/Breadcrumbs-06bff357ceaf48bdbf289a7ff7cdc639)
 */ const Breadcrumbs = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { children, className } = _param, props = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(classes({
            className
        })),
        children: Children.toArray(children).reduce((result, child, index, array)=>{
            // Add the modified child
            result.push(modifyChild(child));
            // Add the chevron if it's not the last child
            if (index < array.length - 1) {
                result.push(/*#__PURE__*/ _jsx(Icon, {
                    icon: "chevron-right",
                    size: "xs",
                    className: "text-primary"
                }, `chevron-${index}`));
            }
            return result;
        }, [])
    }));
});
export { Breadcrumbs };
